import { lazy } from "react";

function load(code) {
  switch (code) {
    case "cron/list":
      return lazy(() => import("views/cron/list"));
    default:
      return null;
  }
}

export default load;
